module.exports = __webpack_public_path__ + "static/media/back-arrow.d8cf2ca4.svg";